import { theme } from '../../styles/theme';
export const loginWeb = {
    width: '100%',
    height: '100%',
    minHeight: 'fit-content',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: { mobile: '24px', desktop: '128px 24px' }
};
export const loginWebWrapper = {
    width: { tablet: '464px', desktop: '1096px' }
};
export const loginWebBox = {
    backgroundColor: theme.palette.common.white,
    borderRadius: '16px',
    padding: { mobile: '24px 27px', tablet: '32px' }
};
//# sourceMappingURL=LoginWeb.styles.js.map